import { InlineNotification } from '@carbon/react';
import { Atom, useAtomValue } from 'jotai';

const FormErrorList = ({
  errorsAtom,
  testId = 'error-section',
  hideCloseButton,
}: {
  errorsAtom: Atom<string[]>;
  testId?: string;
  hideCloseButton?: boolean;
}) => {
  const collectedErrors = useAtomValue(errorsAtom);
  return (
    <div data-testid={testId}>
      {collectedErrors.map((el, i) => {
        return (
          <InlineNotification
            hideCloseButton={hideCloseButton ?? false}
            lowContrast
            key={`${el}-${i}`}
            kind="error"
            title={el}
          />
        );
      })}
    </div>
  );
};

export { FormErrorList };
